import type { OdinIconName } from '@myosh/odin-components';
import { IconButton, OdinIconSize } from '@myosh/odin-components';
import clsx from 'clsx';

interface ActionIconProps {
  icon: OdinIconName;
  onClick: () => void;
  iconStyles?: string;
  hidden?: boolean;
}

const ActionIcon = ({ icon, onClick, hidden = false, iconStyles }: ActionIconProps) => {
  const actionIconClassNames = clsx(
    'group-hover:flex ',
    { 'text-primary-2 hover:text-primary-1': !iconStyles },
    {
      hidden: hidden,
    },
    iconStyles
  );

  return (
    <IconButton
      icon={icon}
      iconSize={OdinIconSize.ExtraSmall}
      iconClassName={actionIconClassNames}
      classNames="h-9 p-1"
      onClick={onClick}
    />
  );
};

export default ActionIcon;
